var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEosSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7899 0.624791C0.827158 0.165808 -0.231189 1.04584 0.0444367 2.07616L2.05964 9.60921C2.16316 9.99621 2.48766 10.2841 2.88425 10.3407L12.7676 11.7526C13.0538 11.7935 13.0538 12.2067 12.7676 12.2476L2.88529 13.6594C2.4887 13.716 2.16421 14.0039 2.06068 14.3909L0.0444365 21.9278C-0.231191 22.9582 0.827162 23.8382 1.7899 23.3792L23.2875 13.1303C24.2369 12.6777 24.2369 11.3263 23.2875 10.8737L1.7899 0.624791Z",
    fill: "url(#paint0_radial_2280_119090)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2280_119090",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0234 21.2469) rotate(-142.006) scale(33.4402 32.3913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336272,
    stopColor: "#ff6d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#e34e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9761"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEosSend);
export default __webpack_public_path__ + "static/media/EosSend.beae5f139db991af4a473faeeb247218.svg";
export { ForwardRef as ReactComponent };